import { TransactionReceipt, ZeroAddress } from 'ethers'
import { useMemo } from 'react'

import { GasFeePayment } from '@ambire-common/libs/accountOp/accountOp'
import { NetworkName, TransactionHistoryItem } from '@railgun-community/shared-models'

type PrivateHistoryItem = TransactionHistoryItem & {
  networkName: NetworkName
}

export const usePrivateGasFeePayment = ({
  item,
  networkChainId,
  receipt,
  isReceiptLoading
}: {
  item: PrivateHistoryItem
  networkChainId: bigint
  receipt: TransactionReceipt | null
  isReceiptLoading: boolean
}) => {
  const nativeGasFeeAmount = useMemo(() => {
    const gasPrice = (receipt as any)?.effectiveGasPrice ?? receipt?.gasPrice ?? null
    if (!receipt || !gasPrice) return null

    return receipt.gasUsed * gasPrice
  }, [receipt])

  const gasFeePayment = useMemo((): GasFeePayment | null => {
    const fee = item.broadcasterFeeERC20Amount
    if (fee?.tokenAddress && fee?.amount != null) {
      return {
        isGasTank: false,
        paidBy: ZeroAddress,
        paidByKeyType: null,
        inToken: fee.tokenAddress,
        amount: fee.amount,
        feeTokenChainId: networkChainId,
        simulatedGasLimit: 0n,
        gasPrice: 0n,
        broadcastOption: 'private-history'
      }
    }

    if (nativeGasFeeAmount != null) {
      return {
        isGasTank: false,
        paidBy: ZeroAddress,
        paidByKeyType: null,
        inToken: ZeroAddress,
        amount: nativeGasFeeAmount,
        feeTokenChainId: networkChainId,
        simulatedGasLimit: 0n,
        gasPrice: 0n,
        broadcastOption: 'private-history'
      }
    }

    return null
  }, [item.broadcasterFeeERC20Amount, nativeGasFeeAmount, networkChainId])

  return {
    gasFeePayment,
    isFeeLoading: !item.broadcasterFeeERC20Amount && isReceiptLoading
  }
}
